import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { DRAWER_DATA } from '@ui/drawer/drawer-data.token';
import { DrawerService } from '@ui/drawer/drawer.service';
import { select } from '@ngxs/store';
import { AtomicModule } from 'src/app/shared/atomic/atomic.module';
import { DropdownResult } from 'src/app/shared/atomic/atoms/dropdown-options/dropdown-options.component';
import { PortalInviteDispatch } from 'src/app/shared/state/portal-invite/portal-invite.dispatch';
import { UiModule } from 'src/app/ui/ui.module';
import { ClientDropdownItem } from '../../view-models/models';
import { $shareIntakeFormModalViewModel } from '../../view-models/selectors';
import { IntakeClientPillComponent } from '../intake-client-pill/intake-client-pill.component';
import { ClientIntakeService } from '@services/client-intake/client-intake.service';
import {
	AnalyticsEvent,
	AnalyticsService,
} from '@services/analytics/analytics.service';

@Component({
	selector: 'app-share-intake-drawer',
	templateUrl: './share-intake-drawer.component.html',
	standalone: true,
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [IntakeClientPillComponent, UiModule, AtomicModule, CommonModule],
})
export class ShareIntakeDrawerComponent {
	private drawerService = inject(DrawerService);
	private drawerData = inject<unknown>(DRAWER_DATA);
	private clientIntakeService = inject(ClientIntakeService);
	private portalInviteDispatch = inject(PortalInviteDispatch);
	private analyticsService = inject(AnalyticsService);

	viewModel_ = select($shareIntakeFormModalViewModel);

	addClientEditAccess($event: DropdownResult<ClientDropdownItem>) {
		this.portalInviteDispatch.AddInvitees({
			inviteId: this.viewModel_().portalInvite.id,
			invitees: [$event.result.value],
		});

		this.analyticsService.logEvent(
			AnalyticsEvent.INTAKE_PARTIES_INTAKE_OVERVIEW_SHARE_ADD,
		);
	}

	sendIntakeEmail() {
		this.clientIntakeService.sendIntakeEmail();
		this.drawerService.closeDrawer();
	}
}
